const API_BASE_URL = (
  import.meta.env.VITE_API_BASE_URL ||
  "http://127.0.0.1:8000"
).replace(/\/$/, "")

const API_URL = API_BASE_URL.endsWith("/api")
  ? API_BASE_URL
  : `${API_BASE_URL}/api`

function buildHeaders() {
  return {
    "Content-Type": "application/json",

    "x-kongosys-user-id":
      localStorage.getItem("kongosys_user_id") || "",
    "x-user-id":
      localStorage.getItem("kongosys_user_id") || "",

    "x-kongosys-role":
      localStorage.getItem("kongosys_role") || "",
    "x-user-role":
      localStorage.getItem("kongosys_role") || "",
    "x-role":
      localStorage.getItem("kongosys_role") || "",

    "x-kongosys-company-id":
      localStorage.getItem("kongosys_company_id") || "1",
    "x-company-id":
      localStorage.getItem("kongosys_company_id") || "1",

    "x-kongosys-organization-id":
      localStorage.getItem("kongosys_organization_id") || "",
    "x-organization-id":
      localStorage.getItem("kongosys_organization_id") || "",

    "x-kongosys-organization-code":
      localStorage.getItem("kongosys_organization_code") || "",
    "x-organization-code":
      localStorage.getItem("kongosys_organization_code") || "",

    "x-kongosys-store-id":
      localStorage.getItem("kongosys_store_id") || "",
    "x-store-id":
      localStorage.getItem("kongosys_store_id") || "",

    "x-kongosys-warehouse-id":
      localStorage.getItem("kongosys_warehouse_id") || "",
    "x-warehouse-id":
      localStorage.getItem("kongosys_warehouse_id") || "",
  }
}

async function request(path, options = {}) {
  const cleanPath = path.startsWith("/")
    ? path
    : `/${path}`

  const response = await fetch(`${API_URL}${cleanPath}`, {
    ...options,
    headers: {
      ...buildHeaders(),
      ...(options.headers || {}),
    },
  })

  let data = null
  const contentType =
    response.headers.get("content-type") || ""

  if (response.status !== 204) {
    if (contentType.includes("application/json")) {
      data = await response.json().catch(() => null)
    } else {
      data = await response.text().catch(() => null)
    }
  }

  if (!response.ok) {
    const message =
      typeof data === "string"
        ? data
        : data?.detail ||
          data?.message ||
          `Erreur API paramètres prix (${response.status}).`

    throw new Error(message)
  }

  return data
}

function buildQuery(params = {}) {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== "undefined" &&
      value !== "null"
    ) {
      searchParams.append(key, String(value))
    }
  })

  const query = searchParams.toString()

  return query ? `?${query}` : ""
}

export function getProductPriceFormData() {
  return request("/product-prices/form-data")
}

export function getProductPrices(params = {}) {
  return request(`/product-prices${buildQuery(params)}`)
}

export function saveProductPriceMatrix(payload) {
  return request("/product-prices", {
    method: "POST",
    body: JSON.stringify(payload),
  })
}

export function createProductPrice(payload) {
  return saveProductPriceMatrix(payload)
}

export function updateProductPrice(productId, payload) {
  return request(`/product-prices/${productId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  })
}

export function deactivateProductPrice(productId) {
  return request(`/product-prices/${productId}/deactivate`, {
    method: "POST",
    body: JSON.stringify({}),
  })
}

export function getEffectiveProductPrice(params = {}) {
  return request(`/product-prices/effective${buildQuery(params)}`)
}